module.exports = __webpack_public_path__ + "media/homepage/HERO-01-e4da6e8b.webp";